export enum MonthlyPartnerProfitSharingStatusEnum {
  AWAITING = 'AWAITING',
  COMPLETED = 'COMPLETED'
}

export enum MonthlyPartnerProfitSharingUploadStatusEnum {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}
